import { render } from "./servicesHistory.vue?vue&type=template&id=82b50b30&ts=true"
import script from "./servicesHistory.vue?vue&type=script&lang=ts"
export * from "./servicesHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__